import request from 'axios';
import { call } from 'redux-saga/effects';
import {get} from './store';
import i18n from '../configuration/i18n';

export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';
export const HEAD = 'HEAD';
export const PATCH = 'PATCH';

const service = (requestType, url, data = {}, config = {}) => {
    const reqConfig = {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFTOKEN',
        ...config,
        headers: {
            Accept: 'application/json',
            'Accept-Language': i18n.language,
            ...(get('token') && {Authorization: `Token ${get('token')}`}),
            ...(get('dashboardToken') && {'X-Dashboard-Token': get('dashboardToken')}),
            ...config.headers,
        },
    };

    switch (requestType) {
        case GET: {
            return call(request.get, url, reqConfig);
        }
        case POST: {
            return call(request.post, url, data, reqConfig);
        }
        case PUT: {
            return call(request.put, url, data, reqConfig);
        }
        case DELETE: {
            return call(request.delete, url, reqConfig);
        }
        case HEAD: {
            return call(request.head, url, reqConfig);
        }
        case PATCH: {
            return call(request.patch, url, data, reqConfig);
        }
        default: {
            throw new TypeError('No valid request type provided');
        }
    }
};

export default service;



// WEBPACK FOOTER //
// /src/services/request.js